export default __webpack_public_path__ + "/dist/images/social-icon.84b2ccc31875370325ce315b23db32a1.svg";